import { CIcon } from '~/icons/types'

export const ciLink: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M7 8h2a1 1 0 0 0 0-2H7a5.965 5.965 0 0 0-4.243 1.757A5.965 5.965 0 0 0 1 12c0 1.603.624 3.109 1.757 4.242A5.958 5.958 0 0 0 7 18h2a1 1 0 1 0 0-2H7a3.973 3.973 0 0 1-2.829-1.172A3.972 3.972 0 0 1 3 12c0-1.068.416-2.073 1.171-2.828A3.975 3.975 0 0 1 7 8Zm14.242-.243A5.959 5.959 0 0 0 17 6h-2a1 1 0 1 0 0 2h2c1.068 0 2.072.416 2.828 1.172A3.97 3.97 0 0 1 21 12a3.971 3.971 0 0 1-1.172 2.828A3.971 3.971 0 0 1 17 16h-2a1 1 0 1 0 0 2h2c1.604 0 3.11-.624 4.242-1.758A5.952 5.952 0 0 0 23 12c0-1.603-.624-3.11-1.758-4.243Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'link',
  type: 'regular'
}
